import { Helmet } from 'react-helmet-async';
import MyDocumentsLayout from '../../components/profile/documents';
import { TITLES } from '../../types/titles';
import { useEffect } from 'react';
import { setDictionary } from '../../services/dictionaries';
import { useLoaderData } from 'react-router-dom';
import { useAppDispatch } from '../../hooks';

const ProfileMyDocuments = () => {
	const dispatch = useAppDispatch();
	const data = useLoaderData();

	useEffect(() => {
		dispatch(
			setDictionary(
				//eslint-disable-next-line
				Object.assign(data as any, {
					dictionaryName: 'periodFilters',
				})
			)
		);
	}, []);

	return (
		<>
			<Helmet>
				<title>{TITLES.PROFILE.DOCUMENTS}</title>
			</Helmet>
			<MyDocumentsLayout />
		</>
	);
};

export default ProfileMyDocuments;
